import React from "react";
import DashboardPeerRating from "../mypeers/dashboardpeerrating";
import Jobs from "./jobs";

const DashBoard = () => {
  return (
    <>     
      <DashboardPeerRating />
      <Jobs />
    </>
  );
};

export default DashBoard;
